import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import '../../../css/TruckVisits/TruckVisit.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { ALL_TRUCK_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { useSelector } from 'react-redux';


const TruckVisit = props => {
    let history = useHistory();
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const [search, setSearch] = useState('');
    const [error, setError] = useState(false);
    const [apiTruckData, setApiTruckData] = useState([]);

    const getTime = (timeStamp) => {
        if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
            let timeStampNum = parseInt(timeStamp);
            return new Date(timeStampNum).toGMTString().split(' ')[4].substring(0, 5)
        }
        return timeStamp
    }
    const getDate = (timeStamp) => {
        if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
            let timeStampNum = parseInt(timeStamp)
            let date = new Date(timeStampNum).toGMTString();
            let day = date.split(' ')[1];
            let month = date.split(' ')[2];
            let year = date.split(' ')[3];
            return `${day}-${month}-${year}`;
            //return date;
        }
        return timeStamp
    }

    useEffect(() => {
        if (history.action === "REPLACE" || history.action === 'POP') {
            setSearch(history.location.state?.truckId);
        }
    }, [])

    const handlechangeSearch = (e) => {
        setSearch(e.target.value);
    };

    const onHandleCard = (event) => {
        apiTruckData?.find((name) => {
            if (name?.terminalName === apiTruckData[event]?.terminalName && name?.createdDate === apiTruckData[event]?.createdDate) {
                history.push({
                    pathname: `/truckDetails/${search}/${name.terminal}/${name.createdDate}`,
                    state: name
                });
            }
        })
    }

    const searchRegistrationNumber = () => {
        if (search?.length > 0) {

            ApiCall(
                'GET',
                trackingBaseURL + ALL_TRUCK_DETAILS_ENDPOINT + `?truckRegnNbr=${search}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',


                },
            ).then((apiData) => {
                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log("in 500");
                        setError(true);
                    }
                    else {
                        console.log('I am 200!');
                        setApiTruckData(apiData);
                        setError(false);
                    }
                }
            });
        }
    };

    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.truckVisitsPageTitle} description={TitleDescription.truckVisitsPageDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofulltruckk">
                <div id="csnobox1truckk">
                    <div className='weathernavbar'>
                        <small id="weathername">Truck Visits </small>
                    </div><hr className='navbarhr' />
                    <div class="toppart">
                        <div class="toppartdiv">
                            <small id="toppartup">Truck Registration Number</small>
                        </div>
                        <div class="toppartwhite">
                            <div class="searchdiv">
                                <input
                                    className="searchtruck"
                                    placeholder="Enter Truck Registration No."
                                    autoComplete="off"
                                    id="search1"
                                    onChange={handlechangeSearch}
                                    value={search}
                                ></input>
                                <div class="searchclickdiv" onClick={searchRegistrationNumber}>
                                    <img id="search1img" src={searchimg} width="15" height="15" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {!error ?
                        <div className="sectionParttruck">
                            <div class="csmobilewidthtruck1">
                                <div class="setleft">
                                    {(apiTruckData?.map((name, index) => {
                                        return (
                                            <div class="bottomleftouttter" key={index} onClick={() => onHandleCard(index)}>
                                                {index < (apiTruckData?.length / 2) &&
                                                    <>
                                                        <div className='cs2card1truck'>
                                                            <div class="truckTripLeftDataDiv">
                                                                <div class="truckTripDataRowDiv">
                                                                    <div class="truckTripDataCol1Div">Terminal</div>
                                                                    <div class="truckTripDataCol2Div">{name?.terminalName}</div>
                                                                </div>
                                                                <div class="truckTripDataRowDiv">
                                                                    <div class="truckTripDataCol1Div">Created</div>
                                                                    <div class="truckTripDataCol2Div">{getDate(name?.createdDate) + ' ' + getTime(name.createdDate)}</div>
                                                                </div>
                                                                {manageProfileDataR?.tileUserType == "Premium" &&
                                                                    <div class="truckTripDataRowDiv">
                                                                        <div class="truckTripDataCol1Div">Status</div>
                                                                        <div class="truckTripDataCol2Div">{name?.status}</div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div class="arrownew">
                                                                <a id="arrowlefttruck"><img src={rightarrow} width="16" height="16" alt="" loading="lazy" /></a>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        );
                                    }))}
                                </div>
                            </div>
                            <div class="csmobilewidthtruck2">
                                <div class="setright">
                                    {(apiTruckData?.map((name, index) => {
                                        return (
                                            <div class="bottomrightlow" key={index} onClick={() => onHandleCard(index)}>
                                                {index >= (apiTruckData?.length / 2) &&
                                                    <div className='cs2card1truck'>
                                                        <div class="truckTripLeftDataDiv">
                                                            <div class="truckTripDataRowDiv">
                                                                <div class="truckTripDataCol1Div">Terminal</div>
                                                                <div class="truckTripDataCol2Div">{name?.terminalName}</div>
                                                            </div>
                                                            <div class="truckTripDataRowDiv">
                                                                <div class="truckTripDataCol1Div">Created</div>
                                                                <div class="truckTripDataCol2Div">{getDate(name?.createdDate) + ' ' + getTime(name?.createdDate)}</div>
                                                            </div>
                                                            {manageProfileDataR?.tileUserType == "Premium" &&
                                                                <div class="truckTripDataRowDiv">
                                                                    <div class="truckTripDataCol1Div">Status</div>
                                                                    <div class="truckTripDataCol2Div">{name?.status}</div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div class="arrownew">
                                                            <a id="arrowlefttruck"><img src={rightarrow} width="16" height="16" alt="" loading="lazy" /></a>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    }))}
                                </div>
                            </div>
                        </div>
                        :
                        <div class="notruckfound">
                            <small id="nodatamessage">No result found</small>
                        </div>
                    }
                </div>
            </div>
            <div class="cs2footer11truck2">
                <Footer />
            </div>
            <div class="cs2footer22truck2">
                <Footer2 />
            </div>

        </div>
    );
};

export default TruckVisit;